import React from 'react'
import CardActions from '@mui/material/CardActions'
import styled from 'styled-components'

import { ActionCardProps } from 'types/TextAnalysis'
import { CardTags } from 'components/Shared/ActionCard/Footer/CardTags'
import { CardMetrics } from 'components/Shared/ActionCard/Footer/CardMetrics'

const Wrapper = styled(CardActions)<{ $show: boolean }>`
  padding: 0 !important;
  padding-left: ${({ $show }) => ($show ? '0.563rem' : 0)} !important;
  display: flex;
  flex-direction: column;
  align-items: normal !important;
  width: 100%;
  @media only screen and (max-width: 700px) {
    padding: 0 !important;
  }
`

const FooterContainer = ({
  showCheckbox,
  cardTags,
  cardMetrics,
  cardMetricsVariant,
}: ActionCardProps) => {
  return (
    <Wrapper id="ta-footer-container" $show={showCheckbox || false}>
      <CardTags cardTags={cardTags} />
      <CardMetrics
        cardMetrics={cardMetrics}
        cardMetricsVariant={cardMetricsVariant}
      />
    </Wrapper>
  )
}

export default React.memo(FooterContainer)
